var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pos-form',{attrs:{"showDeleteButton":this.selectedPosId},on:{"delete-pos":_vm.onDeletePos,"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }